import Component from './SingleRangeSlider';
export default Component;

export const componentName = 'SingleRangeSlider';
